import React from 'react';
import { motion } from 'framer-motion';
import { ThermometerIcon, SparklesIcon, StarIcon } from 'lucide-react';
export function MethodSection() {
  const features = [{
    icon: ThermometerIcon,
    title: 'Zéro thermomètre',
    description: 'La physique fait le travail.'
  }, {
    icon: SparklesIcon,
    title: 'Zéro talent requis',
    description: 'Nos patrons de décoration sont infaillibles.'
  }, {
    icon: StarIcon,
    title: 'Fini Miroir Immédiat',
    description: 'La brillance qui fait dire "Wow" à chaque fois.'
  }];
  return <section className="py-10 md:py-16 px-4 md:px-8 bg-warm-white" data-id="element-141">
      <motion.div initial={{
      opacity: 0
    }} whileInView={{
      opacity: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.8
    }} className="max-w-6xl mx-auto" data-id="element-142">
        <h2 className="font-playfair text-2xl sm:text-3xl md:text-5xl font-bold text-burgundy text-center mb-2 md:mb-4" data-id="element-143">
          Le Secret (La Méthode "Muse Fraise")
        </h2>

        <p className="text-base sm:text-lg md:text-2xl text-gray-600 text-center mb-8 md:mb-12 font-lato italic" data-id="element-144">
          Ce n'est pas de la cuisine. C'est de la magie technique simplifiée.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-8 mb-8 md:mb-12" data-id="element-145">
          {features.map((feature, index) => {
          const Icon = feature.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.15
          }} className="bg-white rounded-xl md:rounded-2xl p-5 md:p-8 shadow-lg text-center" data-id="element-146">
                <div className="w-12 h-12 md:w-16 md:h-16 bg-blush rounded-full flex items-center justify-center mx-auto mb-3 md:mb-4" data-id="element-147">
                  <Icon className="w-6 h-6 md:w-8 md:h-8 text-rose-gold" data-id="element-148" />
                </div>
                <h3 className="font-playfair text-lg md:text-xl font-bold text-burgundy mb-1 md:mb-2" data-id="element-149">
                  {feature.title}
                </h3>
                <p className="text-sm md:text-base text-gray-600 font-lato" data-id="element-150">
                  {feature.description}
                </p>
              </motion.div>;
        })}
        </div>

        <motion.div className="rounded-xl md:rounded-2xl overflow-hidden shadow-xl md:shadow-2xl max-w-4xl mx-auto" whileHover={{
        scale: 1.02
      }} transition={{
        duration: 0.3
      }} data-id="element-151">
          <img src="https://cdn.magicpatterns.com/uploads/8W9RzVNr8Vf5u6d1V1Pger/SALES_PAGE_IMAGE_2.png" alt="Flat lay élégant avec tablette affichant le guide 10 Fraises Magiques, fraises miroir dans un bol doré, étiquettes Maman Chérie et accessoires de décoration sur marbre blanc" className="w-full h-auto" data-id="element-152" />
        </motion.div>
      </motion.div>
    </section>;
}